export interface OptionItem {
  label: string;
  value: string;
}

export const FLIGHT_CLASSES: OptionItem[] = [
  { label: "Economy", value: "Y" },
  { label: "Premium Economy", value: "W" },
  { label: "Business", value: "C" },
  { label: "First Class", value: "F" },
];
